/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CrmIssue, FileService, IssueType} from 'compob2b-libs';
import {SubtaskLinkStore} from './subtask-link.store';
import {NgxDurationInputService} from '../../../../../admin-shared/services/ngx-duration-input.service';
import {translations} from '../../../../../../environments/translations.ru';

interface IssueTypeInf {
  id: number;
  header: string;
  icon: string;
}

@Component({
    selector: 'app-subtask-links-issue',
    templateUrl: './subtask-links-issue.component.html',
    styleUrls: ['./subtask-links-issue.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SubtaskLinksIssueComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() issue: CrmIssue;
  @Input() showForm: boolean;
  showComponent: boolean;

  issueTypes: IssueTypeInf[];
  selectedIssueType: IssueTypeInf;
  form: FormGroup;

  public readonly translations = translations;

  private headerInput: ElementRef;

  @ViewChild('headerInput', {static: false}) set content(content: ElementRef) {
    if (content) {
      this.headerInput = content;
    }
  }

  constructor(private readonly cdr: ChangeDetectorRef,
              private readonly fileService: FileService,
              private readonly durationService: NgxDurationInputService,
              public readonly store: SubtaskLinkStore) {
  }

  ngOnInit(): void {
    this.store.totalSpent = this.issue.spent;
    this.showComponent = false;
    this.issueTypes = this.isEpic ? [
      {id: 1, header: 'Задача', icon: 'task'},
      {id: 2, header: 'История', icon: 'story'},
      {id: 3, header: 'Ошибка', icon: 'bug'}
    ] : [
      {id: 4, header: 'Подзадача', icon: 'subtask'}
    ];

    this.selectedIssueType = this.issueTypes[0];

    this.form = new FormGroup({
      type: new FormControl(this.selectedIssueType.id, Validators.required),
      header: new FormControl('', Validators.required)
    });
  }

  get header(): string {
    return this.form.get('header').value;
  }

  get issueType(): number {
    return this.form.get('type').value;
  }

  ngAfterViewInit(): void {
    this.store.load(this.issue.id);
  }

  ngOnChanges(): void {
    if (this.showForm) {
      this.openForm();
    }
  }

  getImageUri(picture: string, width: number = 96) {
    return picture === null ? null : this.fileService.getImageSrc(picture, width);
  }

  closeForm() {
    this.form.get('header').patchValue('');
    this.showForm = false;
    this.showComponent = false;
    this.cdr.detectChanges();
  }

  openForm() {
    this.showComponent = true;
    this.showForm = true;
    this.cdr.detectChanges();
    this.headerInput.nativeElement.focus();
  }

  get isEpic(): boolean {
    return this.issue.crmIssueType.id === IssueType.EPIC;
  }

  onSubmit() {
    this.store.store(this.issue.id, this.header, this.issueType);
    this.closeForm();
  }

  formatDuration(n: number) {
    return this.durationService.getDurationString(n);
  }

  changeIssueType($event: number) {
    this.selectedIssueType = this.issueTypes.find(item => item.id === $event);
  }

}
